import Html from './HtmlHelper.js';

class TruckRenderLoadingScreen {
    _loadingScreen;
    _footer;

    constructor() {
        this._loadingScreen = Html.getById('truck-render-loading-screen');
        this._footer = Html.select('footer');
    }

    show() {
        this._loadingScreen.classList.add('active');
        this._footer.classList.add('is-disabled');
    }

    hide() {
        this._loadingScreen.classList.remove('active');
        this._footer.classList.remove('is-disabled');
    }
}

export default TruckRenderLoadingScreen;